export default __webpack_public_path__ + "static/media/avanadelogo.45aef28e.png";